import './Base';

import Vue from 'vue';
import ParcelReference from '../Parcel/Reference.vue';

Vue.component('ParcelReference', ParcelReference);
